export function showLoading(containerId, message) {
    const container = document.getElementById(containerId);
    if (container) {
        container.innerHTML = `
      <div class="loading-indicator">
        <div class="spinner"></div>
        <p>${message}</p>
      </div>
    `;
    }
}
export function hideLoading(containerId) {
    const container = document.getElementById(containerId);
    if (container) {
        container.innerHTML = '';
    }
}
export function showError(message, onCancel) {
    const errorElement = document.getElementById('errorMessage');
    if (errorElement) {
        errorElement.innerHTML = `
      <div class="error-content">
        <p class="error-text">${message}</p>
        <button class="cancel-button" id="cancelButton">Cancel</button>
      </div>
    `;
        errorElement.style.display = 'block';
        const cancelButton = document.getElementById('cancelButton');
        if (cancelButton && onCancel) {
            cancelButton.addEventListener('click', onCancel);
        }
    }
}
export function hideError() {
    const errorElement = document.getElementById('errorMessage');
    if (errorElement) {
        errorElement.textContent = '';
        errorElement.style.display = 'none';
    }
}
export function createMetadataHTML(metadata) {
    return `
    <div class="metadata-section">
      <h3>Video Information</h3>
      <div class="metadata-content">
        <img src="${metadata.thumbnail.url}" alt="${metadata.title}" class="video-thumbnail">
        <div class="metadata-details">
          <p class="video-title">${metadata.title}</p>
          <button class="duration-badge">${metadata.durationFormatted}</button>
        </div>
      </div>
    </div>
  `;
}
export function createTitleVariationsHTML(variations) {
    const listItems = variations.map(variation => `<li>${variation}</li>`).join('');
    return `
    <div class="variations-section">
      <h3>AI-Generated Title Variations</h3>
      <ol class="variations-list">
        ${listItems}
      </ol>
    </div>
  `;
}
